import { Route } from "@faire/web-api/Route";
import { props as careersRouteProps } from "@faire/web-api/routes/careers";
import { props as belongingRouteProps } from "@faire/web-api/routes/careers/belonging-at-faire";
import { props as workPolicyRouteProps } from "@faire/web-api/routes/careers/flexible-work-policy";
import { props as jobOpeningsRouteProps } from "@faire/web-api/routes/careers/openings";
import { Switch } from "@faire/web/ui/routing/Switch";
import * as React from "react";
import { Redirect } from "react-router-dom";

import * as RetailerPaths from "@faire/retailer/paths";
import { BelongingAtFairePage } from "@faire/retailer/views/careers/__internal__/BelongingAtFaire/BelongingAtFairePage";
import { FlexibleWorkPolicyPage } from "@faire/retailer/views/careers/__internal__/FlexibleWorkPolicy/FlexibleWorkPolicyPage";
import { JobOpenings } from "@faire/retailer/views/careers/__internal__/JobOpenings/JobOpenings";
import { CareersLandingPage } from "@faire/retailer/views/careers/__internal__/LifeatFaire/CareersLandingPage";

export const Careers = () => {
  return (
    <Switch>
      <Route {...belongingRouteProps} component={BelongingAtFairePage} />
      <Route {...workPolicyRouteProps} component={FlexibleWorkPolicyPage} />
      <Route {...jobOpeningsRouteProps} component={JobOpenings} />
      <Route {...careersRouteProps} component={CareersLandingPage} />
      <Redirect to={RetailerPaths.home()} />
    </Switch>
  );
};
